import { useIntersect, useScroll, useTexture, Text, createInstances, Float, Sparkles } from "@react-three/drei"
import { mainStore } from "../../store"
import { useFrame, useThree } from "@react-three/fiber"

import { Suspense, useEffect, useMemo, useRef } from "react"
import { __ } from "../../utils"
import * as THREE from 'three'




import Team from "../../components/team.jsx"


import TextRight from "../../components/textRight.jsx"
import TextLeft from "../../components/textLeft.jsx"
import TextCenter from "../../components/textCenter.jsx"
import CDF from "../../components/image/CDF.jsx"
import UPB2 from "../../components/image/UPB2.jsx"
import { Acaring } from "../../components/models/acaring/model.jsx"
import Reforestation from "../../components/videos/Reforestation.jsx"
import { Senevisium } from "../../components/models/senevisium/model.jsx"
import Nopal from "../../components/image/Nopal.jsx"
import UPF2 from "../../components/image/UPF2.jsx"
import { FHB } from "../../components/models/FHB/model.jsx"
import CREA from "../../components/image/CREA.jsx"
import Gouvernance from "../../components/image/Gouvernance.jsx"
import PaulEguia from "../../components/image/PaulEguia.jsx"
import ActivelyCaring from "../../components/image/AC.jsx"

export default function BodyChapterFive() {
    // Utils
    const data = useScroll()
    const { width, height } = useThree((state) => state.viewport)


    // Store
    const colors = mainStore.useStore(s => s.colors)
    const fonts = mainStore.useStore(s => s.fonts)
    const scrollMap = mainStore.useStore(s => s.scrollMap)
    const currentChapter = mainStore.useStore((s) => s.current)
    const isUiHidden = mainStore.useStore((s) => s.isUiHidden)
    const preventChapterUpdate = mainStore.useStore(s => s.preventChapterUpdate)

    const lang = mainStore.useStore(s => s.lang)



    const chapters = mainStore.useStore(s => s.chapters)
    const chapter = chapters[4]


    // Refs
    const senevisiumRef = useRef()
    const fhbRef = useRef()

    /**
     * Shaders
     * */




    useFrame(({ clock }) => {

        fhbRef.current.rotation.y = clock.getElapsedTime() * 0.1

        // Chapter auto selector
        // if (data.scroll.current > scrollMap.one && data.scroll.current <= scrollMap.two && !currentChapter.dates.includes(1991) && isUiHidden && !preventChapterUpdate) {
        //     mainStore.selectChapter('UNICITÉ', [1990, 1999])
        // }

        if (data.scroll.current > chapter.start && data.scroll.current <= scrollMap.five) {

            if (!currentChapter.dates.includes(2020) || !currentChapter.dates.includes(2026)) {
                mainStore.preventChapterUpdate(true)
                mainStore.selectChapter(chapter.name[lang === 'fr' ? lang : 'en'], chapter.dates, chapter.start)
                setTimeout(() => mainStore.preventChapterUpdate(false), 1000)

            }
        }
    })




    return <>
        <group position={[0, -111.3, 0]}>
            <TextRight
                maxWidth={4.2}
                fontSize={0.26}
                positionY={0.4}
                positionZ={0}
                fontsOw={fonts.ms.title}
                depthWrite={false}
            >
                2020
            </TextRight>
            <CDF scale={1.1} position={[-3.2, 0, 0]} />
            <group position={[0, -0., 0]}>
                {
                    __(
                        //FR
                        <>
                            <TextRight
                                maxWidth={2}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                lineHeight={1}
                                exposantHeight={0.07}
                                positionY={-0}
                                scale={1}
                                offsetX={0.07}
                                offsetY={-0.2}>
                                Centre de formation
                            </TextRight>
                            <TextRight
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.25}
                                scale={1}
                                offsetX={-0.43}
                                offsetY={-0.4}>
                                Il est doté d’espaces dédiés avec de nombreux équipements high-tech, et d’un amphithéâtre de 200 places.
                            </TextRight>
                        </>,
                        // EN
                        <>
                            <TextRight
                                maxWidth={2}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                lineHeight={1}
                                exposantHeight={0.07}
                                positionY={-0}
                                scale={1}
                                offsetX={0.07}
                                offsetY={-0.2}>
                                Training center
                            </TextRight>
                            <TextRight
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.25}
                                scale={1}
                                offsetX={-0.43}
                                offsetY={-0.4}>
                                It has dedicated areas with a wealth of high-tech equipment, and a 200-seat lecture theater.
                            </TextRight>
                        </>
                    )
                }
            </group>
            <group position={[0, -.8, 0]}>
                {
                    __(
                        //FR
                        <>
                            <TextRight
                                maxWidth={2}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                lineHeight={1}
                                exposantHeight={0.07}
                                positionY={-0}
                                scale={1}
                                offsetX={0.07}
                                offsetY={-0.2}>
                                Engagement auprès de l’initiative Science-Based Target
                            </TextRight>
                            <TextRight
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.15}
                                scale={1}
                                offsetX={-0.43}
                                offsetY={-0.4}>
                                pour rester alignée avec la trajectoire des « 2°C ».
                            </TextRight>
                        </>,
                        // EN
                        <>
                            <TextRight
                                maxWidth={2}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                lineHeight={1}
                                exposantHeight={0.07}
                                positionY={-0}
                                scale={1}
                                offsetX={0.07}
                                offsetY={-0.2}>
                                Commitment to the Science-Based Target initiative
                            </TextRight>
                            <TextRight
                                maxWidth={2}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.15}
                                scale={1}
                                offsetX={-0.43}
                                offsetY={-0.4}>
                                to stay in line with the “2°C” trajectory.
                            </TextRight>
                        </>
                    )
                }
            </group>
            <group position={[0, -2.5, 0]}>
                <UPB2 />
                {/* <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.2}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    20
                </TextLeft> */}
                <group position={[0, 0.6, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={2.5}
                                    fontsOw={fonts.cm.title}
                                    lineHeight={1}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    exposant={'e'}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    2  atelier de production par biotechnologies
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.6}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB construit une seconde ligne de production pour quadrupler la production annuelle des matières premières naturelles issues de micro-organismes.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={2.5}
                                    fontsOw={fonts.cm.title}
                                    lineHeight={1}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    exposant={'nd'}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    2   biotechnology production workshop
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.45}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB is building a second production line to quadruple its annual production of natural raw materials derived from micro-organisms.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
                <group position={[0, -.2, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={2.5}
                                    fontsOw={fonts.cm.title}
                                    lineHeight={1}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={1.72}
                                    offsetY={-0.2}>
                                    Lancement de ACNESIUM
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    exposant={'e'}
                                    offsetX={0.04}
                                    offsetY={-0.39}>
                                    2    actif de SILAB Softcare pour les peaux acnéiques.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={2.5}
                                    fontsOw={fonts.cm.title}
                                    lineHeight={1}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Launch of ACNESIUM
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.42}
                                    scale={1}
                                    exposant={'nd'}
                                    offsetX={0.55}
                                    offsetY={-0.41}>
                                    SILAB Softcare's 2      active ingredient for skin prone to acne.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
            </group>
            <group position={[0, -5, 0]}>
                <TextRight
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.4}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2021
                </TextRight>
                <Acaring scale={0.07} position={[-1, 0, 1.25]} />
                <group position={[0, -0.2, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={1.8}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Création du programme RSE Actively Caring
                                </TextRight>
                                <TextRight
                                    maxWidth={1.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.25}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    afin d’articuler ses actions durables autour d’un programme à 5 ans.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={1.8}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Creation of the Actively caring CSR program
                                </TextRight>
                                <TextRight
                                    maxWidth={1.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.25}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    in order to structure its sustainable actions around a 5-year program.
                                </TextRight>
                            </>
                        )
                    }
                </group>
                <Reforestation position={[1.5, -2.6, 1]} />
                <group position={[0, -1.6, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={1.8}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Participation à un projet label bas carbone
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.38}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB s’associe avec le CNPF (Centre national de la propriété forestière) pour co-financer un projet de reforestation local.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={1.8}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Participation in a low carbon label project
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    positionY={-.4}
                                    exposant={'Centre national de la propriété forestière'}
                                    expFont={fonts.ms.italic}
                                    exposantHeight={0.062}
                                    scale={1}
                                    offsetX={0.45}
                                    offsetY={-0.485}
                                >
                                    SILAB is working with the French national forest ownership center (CNPF,                                                                                ) to co-finance a local reforestation project.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
                <group position={[0, -2.4, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={1.8}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Membre de l’UEBT
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB s'engage pour un monde dans lequel les Hommes et la biodiversité sont traités avec respect.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={1.8}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Member of the UEBT
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB is committed to a world in which people and biodiversity are treated with respect.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
            </group>
            <group position={[0, -9.6, 0]}>
                <TextRight
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.4}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2023
                </TextRight>
               
                <Gouvernance scale={1.2} position={[-3.2, -0.6, 0]} />
                <group position={[0, -0.2, 0]}>

                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Nouveau modèle de gouvernance
                                </TextRight>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.15}
                                    scale={1}
                                    offsetX={-0.67}
                                    offsetY={-0.09}>
                                    avec un Conseil de surveillance et un Directoire.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    New governance model
                                </TextRight>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.15}
                                    scale={1}
                                    offsetX={-0.67}
                                    offsetY={-0.09}>
                                    with a supervisory board and a management board.
                                </TextRight>
                            </>
                        )
                    }
                </group>
                <group position={[0, -0.65, 0]}>

                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    exposant={'re'}
                                    scale={1}
                                    offsetX={-1.28}
                                    offsetY={0.15}
                                    >
                                    1  attestation For Life
                                </TextRight>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.15}
                                    scale={1}
                                    offsetX={-0.67}
                                    offsetY={-0.09}>
                                    une labellisation attribuée par Ecocert, pour la stratégie RSE de SILAB.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    exposant={'st'}
                                    scale={1}
                                    offsetX={-1.32}
                                    offsetY={0.15}
                                >
                                    1   For Life attestation
                                </TextRight>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.15}
                                    scale={1}
                                    offsetX={-0.67}
                                    offsetY={-0.09}
                                >
                                    a label awarded by Ecocert, for SILAB's CSR strategy.
                                </TextRight>
                            </>
                        )
                    }
                </group>
                <group position={[0, -1.3, 0]}>

                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.055}
                                    offsetY={-0.01}>
                                    Engagement auprès du Pacte mondial des Nations Unies
                                </TextRight>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.25}
                                    scale={1}
                                    offsetX={-0.67}
                                    offsetY={-0.09}>
                                    et de ses Dix principes autour des droits de l’Homme, des normes du travail, de l’environnement et de la lutte contre la corruption.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={2}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.055}
                                    offsetY={-0.01}
                                >
                                    Commitment to the United Nations Global Compact
                                </TextRight>
                                <TextRight
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.25}
                                    scale={1}
                                    offsetX={-0.67}
                                    offsetY={-0.09}
                                >
                                    and its Ten Principles around human rights, labor, environment, and anti-corruption.
                                </TextRight>
                            </>
                        )
                    }
                    <Team scale={0.6} offsetNumber={-0.12} position={[-width * (0.2 + 0.03), -2, 2]}>
                        400
                    </Team>
                </group>
                {/* <Nopal position={[0, -2.8, 0]} /> */}
                 <Senevisium ref={senevisiumRef} scale={0.15} rotation={[0, -0.5, 0]} position={[2, -3.2, 1]} />
                <group position={[0, -2.4, 0]}>

                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Mécanisme d’immunoévasion et sénescence
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposant={'in vitro'}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={1.45}
                                    offsetY={-0.4}>
                                    Grâce à des études de modélisation originales               , SILAB met en évidence l’accentuation du phénomène d’immunoévasion des fibroblastes sénescents du derme.
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.7}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={1.495}
                                    offsetY={-0.7}>
                                    Ces découvertes sont à l’origine de SENEVISIUM   , actif naturel recommandé dans tous les soins pour peaux matures.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Mechanism of immunoevasion and senescence
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposant={'in vitro'}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={0.579}
                                    offsetY={-0.4}>
                                    Thanks to original                modeling studies, SILAB highlights the accentuation of the immunoevasion mechanism of senescent fibroblasts in the dermis.
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.7}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={1.545}
                                    offsetY={-0.7}>
                                    These discoveries are at the origin of SENEVISIUM   , a natural active ingredient recommended in all skincare products for mature skin.
                                </TextLeft>
                            </>
                        )
                    }

                </group>
                <group position={[0, -3.5, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.055}
                                    offsetY={-0.01}>
                                    Site internet dédié à la RSE
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={-0.67}
                                    offsetY={-0.09}>
                                    Éco-conçu, ce site présente les engagements et initiatives du programme RSE Actively Caring.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.055}
                                    offsetY={-0.01}>
                                    Dedicated CSR website
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={-0.67}
                                    offsetY={-0.09}>
                                    Eco-designed, this website presents the commitments and initiatives of the Actively Caring CSR program.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
            </group>
            <group position={[0, -15.1, 0]}>

                <TextRight
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.5}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2024
                </TextRight>
                <UPF2 position={[-3.1, -0.4, 0]} scale={1.2} />
                <group position={[0, -0., 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    exposant={'®'}
                                    scale={1}
                                    positionX={-0.003}
                                    offsetX={0.00}
                                    offsetY={0.17}
                                >
                                    Lancement des SILAFILM
                                </TextRight>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.3}
                                    exposant={['®', '®']}
                                    expOffsetArray={[
                                        [-1.1, 0.09],
                                        [-0.36, 0.09]
                                    ]}
                                    scale={1}
                                >
                                    Cette technologie révolutionnaire de diffusion d’actifs dans la peau conduit au développement de deux premiers films secs :                                      SILAFILM    Radiance et SILAFILM    Pureness.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    exposant={'®'}
                                    positionX={-0.003}
                                    offsetX={0.00}
                                    offsetY={0.17}
                                >
                                    Launch of SILAFILM
                                </TextRight>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.3}
                                    exposant={['®', '®']}
                                    expOffsetArray={[
                                        [-1.159, 0.09],
                                        [-0.36, 0.09]
                                    ]}
                                    scale={1}
                                >
                                    This revolutionary technology for diffusing active ingredients into the skin leads to the development of the first two dry films:                                             SILAFILM    Radiance and SILAFILM    Pureness.
                                </TextRight>
                            </>
                        )
                    }
                </group>
                <group position={[0, -0.7, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.00}
                                    offsetY={0.17}
                                >
                                    Création de SILAB North East Asia
                                </TextRight>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.3}
                                    scale={1}
                                >
                                    implantée au Japon. Cette filiale a en charge la promotion et la distribution des actifs sur le marché domestique japonais, ainsi que l’accompagnement dans le développement du marché sud-coréen.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    offsetX={0.00}
                                    offsetY={0.17}
                                >
                                    Creation of SILAB North East Asia
                                </TextRight>
                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    expFont={fonts.ms.italic}
                                    positionY={-.3}
                                    scale={1}
                                >
                                    based in Japan. This subsidiary is responsible for the promotion and distribution of active ingredients on the Japanese domestic market, as well as supporting the development of the South Korean market.
                                </TextRight>
                            </>
                        )
                    }
                </group>
            </group>
            <group position={[0, -17.7, 0]}>
                <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.6}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2025
                </TextLeft>
                <group rotation={[-0., 0, Math.PI * 0.5]} position={[2.1, -2, 0]}>
                    <FHB ref={fhbRef} scale={0.38} position={[1.8, -0, 1.5]} />
                </group>
                <group position={[0, 0.15, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={1.8}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    exposant={'®'}
                                    offsetX={1.03}
                                    offsetY={-0.02}>
                                    FHB technology
                                </TextLeft>
                                <TextLeft
                                    maxWidth={1.8}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    positionY={-.2}
                                    scale={1}
                                    exposant={['Functionalized helical biopolymer technology', '®', '®']}
                                    expFont={fonts.ms.italic}
                                    expOffsetArray={[
                                        [0.29, -0.285],
                                        [1.725, -0.29],
                                        [1.5175, -0.37],
                                    ]}
                                >
                                    La Recherche SILAB a développé une technologie inédite brevetée                                                                                            , qui a conduit au développement de LIFTILIENCE   , sixième actif phytotenseur.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={1.8}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-0}
                                    scale={1}
                                    exposant={'®'}
                                    offsetX={1.03}
                                    offsetY={-0.02}>
                                    FHB technology
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.2}
                                    scale={1}
                                    exposant={['®', '®']}
                                    expOffsetArray={[
                                        [1.425, -0.29],
                                        [1.0955, -0.37],
                                    ]}
                                >
                                    SILAB Research has developed a unique technology: Functionalized helical biopolymer technology   , which has led to the development of LIFTILIENCE   , the sixth phytotensor active ingredient.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
            </group>
            <group position={[0, -20.8, 0]}>
                {
                    __(
                        //FR
                        <>
                            <TextRight
                                maxWidth={1.8}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                lineHeight={1}
                                exposantHeight={0.07}
                                positionY={-0}
                                scale={1}
                                offsetX={1.03}
                                offsetY={-0.02}>
                                Centre de recherche et d’études agronomiques
                            </TextRight>
                            <TextRight
                                maxWidth={1.8}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.062}
                                positionY={-.25}
                                scale={1}
                            >
                                Acquisition d’une ferme de 6 hectares à proximité de SILAB.
                            </TextRight>
                        </>,
                        // EN
                        <>
                            <TextRight
                                maxWidth={1.8}
                                fontsOw={fonts.cm.title}
                                fontSize={0.16}
                                lineHeight={1}
                                exposantHeight={0.07}
                                positionY={-0}
                                scale={1}
                                offsetX={1.03}
                                offsetY={-0.02}>
                                Agronomic research and study center
                            </TextRight>
                            <TextRight
                                maxWidth={1.8}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.062}
                                positionY={-.15}
                                scale={1}
                            >
                                Acquisition of a 6-hectare farm near SILAB.
                            </TextRight>
                        </>
                    )
                }
            </group>
            <CREA position={[-3.3, -20.8, 0]} scale={1.3} />


            <group position={[0, -22.2, 0]}>
            {
                __(
                    //FR
                    <>
                        <TextLeft
                            maxWidth={2.5}
                            fontsOw={fonts.cm.title}
                            lineHeight={1}
                            fontSize={0.16}
                            exposantHeight={0.07}
                            positionY={-.2}
                            scale={1}
                            offsetX={0.07}
                            offsetY={-0.2}>
                            Continuité familiale
                        </TextLeft>

                        <TextLeft
                            maxWidth={2.3}
                            fontsOw={fonts.ms.text}
                            fontSize={0.062}
                            lineHeight={1.4}
                            exposantHeight={0.05}
                            positionY={-0.5}
                            scale={1}
                            offsetX={0.33}
                            offsetY={-0.48}>
                            En septembre, Paul EGUIA, petit-fils du fondateur, a rejoint le directoire en qualité de directeur général en charge de l'intelligence économique. 
                        </TextLeft>
                    </>,
                    // EN
                    <>
                        <TextLeft
                            maxWidth={2.5}
                            fontsOw={fonts.cm.title}
                            lineHeight={1}
                            fontSize={0.16}
                            exposantHeight={0.07}
                            positionY={-.2}
                            scale={1}
                            offsetX={0.07}
                            offsetY={-0.2}>
                            Family continuity
                        </TextLeft>

                        <TextLeft
                            maxWidth={2.3}
                            fontsOw={fonts.ms.text}
                            fontSize={0.062}
                            lineHeight={1.4}
                            exposantHeight={0.05}
                            positionY={-.58}
                            scale={1}
                            offsetX={0.58}
                            offsetY={-0.56}>
                            In September, Paul Eguia, grandson of the founder, joined the management board as general manager in charge of economic intelligence. 
                        </TextLeft>
                    </>
                )
            }
            </group>
            <PaulEguia position={[-0.2, -23, 0.1]} scale={1.18} />
            
            <group position={[0, -25.6, 0]}>
                <TextRight
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.6}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false} 
                    >
                    2026
                </TextRight>  
                <group position={[0, 0.2, 0]}>
                {
                    __(                  
                        //FR
                        <>
                            <TextRight
                                maxWidth={2.0}
                                fontsOw={fonts.cm.title}
                                lineHeight={1}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-.2}
                                scale={1}
                                offsetX={0.07}
                                offsetY={-0.2}>
                                Actively Caring 2030, un plan de progrès durable 
                            </TextRight>

                            <TextRight
                                maxWidth={2.3}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-0.4}
                                scale={1}
                                offsetX={0.33}
                                offsetY={-0.48}>
                                Création d’une nouvelle feuille de route à 5 ans.
                            </TextRight>
                        </>,
                        // EN
                        <>
                            <TextRight
                                maxWidth={2.0}
                                fontsOw={fonts.cm.title}
                                lineHeight={1}
                                fontSize={0.16}
                                exposantHeight={0.07}
                                positionY={-.2}
                                scale={1}
                                offsetX={0.07}
                                offsetY={-0.2}>
                                Actively Caring 2030, a sustainable improvement plan
                            </TextRight>

                            <TextRight
                                maxWidth={2.3}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-0.4}
                                scale={1}
                                offsetX={0.58}
                                offsetY={-0.56}>
                                Creation of a new five-year roadmap. 
                            </TextRight>
                        </>
                    )
                }
                </group>
           </group>
            <ActivelyCaring position={[-3.3, -25.5, 0.3]} scale={1.24} />

        </group>

    </>
}